<template>
  <div class="payment-methods">
    <div class="text-center">
      <h2>PAYMENT METHODS</h2>
      <p>You can have up to 2 credit or debit cards in your account.</p>
      <section-info id="payment" :hideFooter="true">
        <template slot="header">CREDIT &amp; DEBIT CARDS</template>
        <template slot="main">
          <payment-card-list
            :paymentCards="paymentCards"
            @removeCard="removeCard"
          />
          <div
            v-if="paymentCards.length < 2"
            class="gold-link pt-4"
            tabindex="0"
            @keydown.enter="addPaymentInfo"
            @click="addPaymentInfo"
          >
            ADD PAYMENT METHOD
          </div>
        </template>
      </section-info>
    </div>
    <custom-modal
      v-model="showCardInfo"
      title="ADD PAYMENT METHOD"
      class="add-card-modal"
      :mobile-full-screen="false"
      centered
      hide-footer
      no-close-on-backdrop
      @hide="hideModal"
    >
      <payment-provider
        :init-request-func="initProviderRequest"
        :complete-request-func="completeProviderRequest"
        :payment-provider-id="paymentProviderId"
        :error-message="modalErrorMessage"
      />
    </custom-modal>
  </div>
</template>

<script>
import PaymentProvider from '@/components/paymentProvider/PaymentProvider'
import PaymentCardList from '@/components/common/PaymentCardList'
import SectionInfo from '@/components/checkout/SectionInfo'
import CustomModal from '@/components/common/CustomModal'
import * as transactionTypes from '@/store/mutation-types/transactionMutations'
import { SHOW_CONFIRM_DIALOG } from '@/store/mutation-types/confirmDialogMutations'
import { getErrorMessageString } from '@/common/errorCodeMapper'
import { UCOM_PROVIDER_ID } from '@/constants/paymentProviders'

export default {
  components: {
    PaymentCardList,
    PaymentProvider,
    SectionInfo,
    CustomModal,
  },
  computed: {
    paymentCards() {
      return this.$store.getters.wallet
    },
  },
  data() {
    return {
      showCardInfo: false,
      modalErrorMessage: '',
      paymentProviderId: undefined,
    }
  },
  methods: {
    addPaymentInfo() {
      this.$store
        .dispatch(transactionTypes.GET_PAYMENT_PROVIDER)
        .then((res) => {
          this.paymentProviderId =
            res.data && res.data.length ? res.data[0].paymentProviderId : null
          this.showCardInfo = true
        })
        .catch(() => {
          this.$store.dispatch(SHOW_CONFIRM_DIALOG, {
            headerText: 'Payment Provider',
            text: 'Something unexpected happened.',
            subText: 'Please try again or contact customer support.',
            hideCancel: true,
          })
        })
    },
    hideModal() {
      this.showCardInfo = false
      this.modalErrorMessage = ''
    },
    initProviderRequest() {
      return this.$store
        .dispatch(
          transactionTypes.INIT_PAYMENT_PROVIDER_TOKENIZATION,
          this.paymentProviderId,
        )
        .then((res) => {
          return res.data
        })
        .catch((e) => {
          throw new Error(this.parseError(e))
        })
    },
    completeProviderRequest(clientToken, accessToken) {
      const paymentTokenRequest = {
        clientToken,
        paymentProviderId: this.paymentProviderId,
      }
      if (this.paymentProviderId === UCOM_PROVIDER_ID) {
        paymentTokenRequest.accessToken = accessToken;
      }
      return this.$store
        .dispatch(
          transactionTypes.GET_TOKENIZED_PAYMENT_INFO,
          paymentTokenRequest,
        )
        .then((tokenizedCardInfo) => {
          return this.$store.dispatch(
            transactionTypes.SAVE_CARD_TO_WALLET,
            tokenizedCardInfo,
          )
        })
        .then(() => {
          this.showCardInfo = false
        })
        .catch((e) => {
          throw new Error(this.parseError(e))
        })
    },
    parseError(e) {
      return (
        getErrorMessageString(e, '<br/>') ||
        'We encountered an error saving your card.<br/>Please check your card info and try again.'
      )
    },
    removeCard(card) {
      if (card && card.tokenId) {
        this.$store.dispatch(
          transactionTypes.DELETE_CARD_FROM_WALLET,
          card.tokenId,
        )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins/links.scss';
.payment-methods {
  background-color: $catering-bg-grey;
  padding-bottom: 40px;
  padding-top: 20px;

  .gold-link {
    @extend %gold-link;
    font-size: 18px;
  }

  p {
    font-size: 14px;
  }

  section {
    margin-top: 1rem;
  }
}

.add-card-modal {
  .modal-header {
    height: 50px;
  }
}

.back-btn {
  margin: auto;
  width: 91.4%; // button needs to match section-info's width on smaller screens
}

.payment-provider {
  padding: 16px 0;
}

@include media-breakpoint-up(lg) {
  #content {
    .back-btn {
      max-width: 200px;
    }
  }
}
</style>
